// src/hooks/useCountryCheckQuery.ts
import { useImmutableQuery } from "@repo/queries";
var useCountryCheckQuery = () => {
  return useImmutableQuery("/country/check");
};

// src/hooks/useCountryRegisterQuery.ts
import { useImmutableQuery as useImmutableQuery2 } from "@repo/queries";
var useCountryRegisterQuery = () => {
  return useImmutableQuery2("/country/register");
};

// src/hooks/useCountryRegistrationDropdownQuery.ts
import { useImmutableQuery as useImmutableQuery3 } from "@repo/queries";
var useCountryRegistrationDropdownQuery = () => {
  return useImmutableQuery3("/country/registration-dropdown");
};

// src/TranslationProvider.tsx
import { captureException } from "@sentry/browser";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var TranslationContext = createContext(
  void 0
);
var TranslationProvider = ({
  children,
  loadJson
}) => {
  const [lang, setLang] = useState();
  const { data: countriesArray } = useCountryRegistrationDropdownQuery();
  const { data: countryRegisterResponse, isLoading: isLoadingCountryRegister } = useCountryRegisterQuery();
  const Countries = useMemo(() => {
    if (isLoadingCountryRegister) return void 0;
    const countriesObj = {};
    countryRegisterResponse?.forEach(({ id, name }) => {
      countriesObj[name?.toUpperCase()] = id;
    });
    return countriesObj;
  }, [countryRegisterResponse, isLoadingCountryRegister]);
  const formatKey = (key) => {
    return key?.replaceAll(".", "/");
  };
  const translate = (key, defaultValue) => {
    if (!lang || !key) return void 0;
    const translation = key.split(".").reduce((previousKey, currentKey) => {
      if (previousKey && typeof previousKey === "object" && currentKey in previousKey) {
        return previousKey[currentKey];
      }
      captureException(
        new Error(
          `Missing key: ${formatKey(key)} for locale: ${process.env.GATSBY_INTL_LOCALE}`
        )
      );
      return defaultValue ? defaultValue : formatKey(key);
    }, lang);
    return translation;
  };
  useEffect(() => {
    const loadTranslations = async () => {
      const messages = await loadJson?.();
      setLang(messages);
    };
    loadTranslations();
  }, [loadJson]);
  const value = useMemo(
    () => ({
      lang,
      translate,
      Countries,
      countriesArray
    }),
    [lang, translate, Countries, countriesArray]
  );
  return /* @__PURE__ */ jsx(TranslationContext.Provider, { value, children });
};
var useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    return {
      translate: () => void 0,
      Countries: void 0,
      countriesArray: void 0,
      lang: void 0
    };
  }
  const { translate, Countries, countriesArray, lang } = context;
  return { translate, Countries, countriesArray, lang };
};
export {
  TranslationProvider,
  useCountryCheckQuery,
  useCountryRegisterQuery,
  useCountryRegistrationDropdownQuery,
  useTranslation
};
